import * as Common from '_common';
import { RenderDashboardRoomButton, RenderDashboardRoomFull, RenderHotWaterPumpButtonRender, RenderProcessButton, } from './Dashboard';
import { GraphsRender } from './Graphs';
import * as React from 'react';
export function houseComponentRegister(type) {
    switch (type) {
        case 'graphs':
            return GraphsRender;
        case 'dashboardroombutton':
            return RenderDashboardRoomButton;
        case 'dashboardroomfull':
            return RenderDashboardRoomFull;
        case 'hotwaterpumpbutton':
            return RenderHotWaterPumpButtonRender;
        case 'processbutton':
            return RenderProcessButton;
    }
}
export function useHouseWidgets() {
    const spa = Common.useSpaContext();
    const result = React.useMemo(() => {
        const result = [];
        const state = spa.state;
        if (state) {
            for (const item of Object.keys(state)) {
                const stateItem = state[item];
                if (stateItem.type?.toLowerCase() === 'room') {
                    const widget = {
                        id: item,
                        title: {
                            en: stateItem.name || item,
                            cs: stateItem.name || item,
                        },
                        components: {},
                    };
                    result.push(widget);
                }
            }
        }
        return result;
    }, [spa.state]);
    return result;
}
// export function Cmp(component: Common.IComponent, index?: number): React.ReactNode {
// }
